import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { ErrorModalService } from './error-modal.service';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [TranslatePipe, ButtonComponent],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
  readonly errorModal = inject(ErrorModalService);

  onAccept(): void {
    this.errorModal.hide();
  }
}
